'use strict';
'use es6';

/**
 * Returns the value converted to a string.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toString;
function toString(value) {
  return String(value);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/toString.js
// module id = 392
// module chunks = 0 1